import { useEffect, useRef, useState } from "react";
import { initDB, saveChapterUnitName } from "../ConfigureIndexedDB";

const Chapterunitlist = ({chapterName,unit1,unit2,unit3,unit4,unit5,unit6,unit7,unit8,unit9,unit10,unitchaptername}) => {
    const [droplist,setDropList]=useState(false);
    const subref = useRef();

    useEffect(()=>{
        const cleardroplist =(e)=>{
            if(!subref.current.contains(e.target)){
                setDropList(false);
            }
        }
        document.addEventListener('mousedown',cleardroplist);
        return()=>{
            document.removeEventListener('mousedown',cleardroplist);
        }
    },[]);

    const storeChapterUnitName=(unitname,cname)=>{
        initDB().then(()=>{
            saveChapterUnitName({
                id: "cun",
                unit_name: unitname,
                chapter_name: cname
            }).then((res)=>{
                if(res === true){
                    unitchaptername(unitname,cname);
                }
            }).catch((err)=>{
                console.log(err);
            })
        }).catch((err)=>{
            console.log(err);
        })
    };


    return ( 
        <div className="authusertopcontent" key={chapterName} ref={subref}>
            <div className="flex-row2" onClick={()=>setDropList(prev => !prev)}>
            <h3>{chapterName}</h3>
            <svg
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="black"
              height="1.5em"
              width="1.5em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>
            </div>

            {droplist && 
                <div className="subunits flex-column2">
                    <button onClick={()=>storeChapterUnitName(unit1,chapterName)}>{unit1}</button>
                    {unit2 && <button onClick={()=>storeChapterUnitName(unit2,chapterName)}>{unit2}</button>}
                    {unit3 && <button onClick={()=>storeChapterUnitName(unit3,chapterName)}>{unit3}</button>}
                    {unit4 && <button onClick={()=>storeChapterUnitName(unit4,chapterName)}>{unit4}</button>}
                    {unit5 && <button onClick={()=>storeChapterUnitName(unit5,chapterName)}>{unit5}</button>}
                    {unit6 && <button onClick={()=>storeChapterUnitName(unit6,chapterName)}>{unit6}</button>}
                    {unit7 && <button onClick={()=>storeChapterUnitName(unit7,chapterName)}>{unit7}</button>}
                    {unit8 && <button onClick={()=>storeChapterUnitName(unit8,chapterName)}>{unit8}</button>}
                    {unit9 && <button onClick={()=>storeChapterUnitName(unit9,chapterName)}>{unit9}</button>}
                    {unit10 && <button onClick={()=>storeChapterUnitName(unit10,chapterName)}>{unit10}</button>}
                    {chapterName && <button onClick={()=>storeChapterUnitName(chapterName,chapterName)}>{chapterName}</button>}
                </div>
            }
     
        </div>
     );
}
export default Chapterunitlist;